export function Footer() {
  return (
    <footer className="app-footer">
      <div className="app-footer__inner">
        <p className="footer__text">
          Runtime Lens v1.0.0-beta.1
        </p>
        <p className="footer__sub">
          Estimates only. Verify with manufacturer data for critical applications.
        </p>
      </div>
    </footer>
  )
}
